import { useContext } from 'react';
import { AppContext } from '../../../context/App/AppContext';
import Notification from '../../../components/UI/Notification/Notification';
import Title from '../../../components/UI/Title/Title';
import { isMembershipPaid } from '../../../shared/userFunctions';

const ClientStatusNotification = () => {
  const { userData } = useContext(AppContext);
  const { status, name, last_name } = userData;

  const waitingForApproval = (
    <div>
      Thank you for registering your account. Please allow 1 working day for your account to be reviewed, however this
      may take longer in some cases. Please log back into your account after 1 working day after which you should be
      able to start making your bookings.
      <p>
        Please note at some sites, the estate team will manage account approvals instead of motive8, in such
        circumstance your enquiry will be referred to your respective estate team for more assistance.
      </p>
      <p>
        {' '}
        Please contact us on
        <span>
          {' '}
          on{' '}
          <a href={`mailto:inductions@m8group.co.uk?subject=${name}%20${last_name}-Status`}>
            <u>inductions@m8group.co.uk</u>
          </a>{' '}
        </span>
        along with your full name and postcode if your account is not approved after 1 working day.
      </p>
    </div>
  );
  const permissionDenied = 'Your access to the gym has been denied, if you believe this is an error please contact us.';
  const inactive = 'Your account has been marked as inactive, if you think this is an error please contact us.';
  const membershipNotPaid = 'Your membership plan expired. Please contact us.';
  const shouldShowMembershipExpired = status === 'active' && !isMembershipPaid(userData);

  return (
    <>
      <Title title={status === 'inactive' ? 'Your account is inactive.' : 'Your account needs approval'} />
      <Notification
        status={['inactive', 'permissionDenied'].includes(status) ? 'critical' : 'warning'}
        className={status === 'waitingForApproval' ? 'bg-gray-100 border-gray-300' : ''}>
        {status === 'waitingForApproval'
          ? waitingForApproval
          : status === 'permissionDenied'
            ? permissionDenied
            : shouldShowMembershipExpired
              ? membershipNotPaid
              : inactive}
      </Notification>
    </>
  );
};

export default ClientStatusNotification;
